import { SharedPortalService } from './../../../../../components/user-dashboard/portal/shared-portal.service';
import { TemplateItem } from './../../../../../components/user-dashboard/portal/portal.model';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import {
  LearmoModalRef,
  LearmoModalService,
} from '../../../../../shared/services/learmo-modal.service';

export enum InvitationCurrentStepEnum {
  input = 'input',
  result = 'result',
}
@Component({
  selector: 'app-template-item-info-popup',
  templateUrl: './template-item-info-popup.component.html',
  styleUrls: ['./template-item-info-popup.component.css'],
})
export class TemplateItemInfoPopupComponent implements OnInit {
  // @Output() OnSelect = new EventEmitter<
  @Input() selected: boolean = false;

  @Input() onClickUsePopup: EventEmitter<TemplateItem> =
    new EventEmitter<TemplateItem>();

  @Input() item: TemplateItem;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalFooter') modalFooter: TemplateRef<any>;
  @Input() modalRef: LearmoModalRef;
  constructor(
    private modalService: LearmoModalService,
    public sharedPortalService: SharedPortalService
  ) {}

  async ngOnInit() {}

  resetModal() {}
  closeModal() {
    this.modalRef.dismiss();
    this.resetModal();
  }

  useActionPopup() {
    this.onClickUsePopup.emit(this.item);
  }
  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: 'Template Details', // Added a default title, logic might need dynamic title if item has one
      // icon: 'layout', // Optional: could add an icon if suitable
      footer: this.modalFooter,
      premium: true,
      size: 'xl', // 'informative-item-view-window' usually implies large. Let's explicitly use xl or lg. The original code had size: 'lg'.
    });
  }

  async onOpenModal() {
    // this.resetForm();
    // this.productObject.type_id = 1;
  }
}
